<template>
    <div>
        <div class="">
            <!-- shape Hero -->
            <section class="section-shaped my-0 pb-lg-5">
                <div class="shape shape-style-1 shape-default shape-skew">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="shape-container d-flex pt-4" v-bind:class="{'container': storeDetails.ui_layout==1 ? true : false , 'container-fluid pr-5 pl-5': storeDetails.ui_layout==2 ? true : false}">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-sx-6 col-md-6 col-lg-6">
                                <h1 class="display-3  mb-0">
                                    <small v-if="$route.params.collectionId!=null">{{this.collection_name}}</small>
                                    <small v-else > Products </small>
                                </h1>
                                <p class="">{{ $route.params.collectionId!=null ? this.collection_description : ""}}</p>
                            </div>
                            <div class="col-sx-6 col-md-6 col-lg-6">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 pb-2 d-flex align-items-end">
                                <div class="form-group mr-auto mb-0" v-if="search==null || search == undefined">
                                    <label for="staticEmail2" class=" mr-2">Sort by </label>
                                    <a-select v-model="sortBy" style="width: 180px">
                                        <a-select-option v-for="data in SortbyData" :value="data.value" :key="data.key">
                                            {{ data.name }}
                                        </a-select-option>
                                    </a-select>
                                </div>
                                <a-input-search v-else placeholder="input search text" class="mr-auto" v-model="search" style="width: 200px" @search="onSearch" />
                                <p class=" mb-0">{{gData.length}} {{gData.length>1 ? "items" : "item"}}</p>
                            </div>
                        </div>
                        <hr class="m-0 bg-white">
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>
        <section class="section section-lg pt-lg-0 pb-0">
            <div class="justify-content-center" v-bind:class="{'container': storeDetails.ui_layout==1 ? true : false , 'container-fluid  pr-5 pl-5': storeDetails.ui_layout==2 ? true : false}">
                <a-spin :spinning="spinning" v-bind:style="[spinning ? {'height':'30rem!important'} : {}]">
                    <div class="row" v-if="storeDetails.ui_layout==2">
                        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 pb-2">
                            <div class="card-wrapper d-flex justify-content-center">
                                <div class="bg-F9F9F9 filter-tag">
                                    <div class="inline field">
                                        <div class="p-2 pr-3 pl-3">
                                            <h3 class="heading-large text-dark mb-0">FILTER</h3>
                                        </div>
                                        <hr class="m-0" />
                                        <div class="p-3">
                                            <a-checkbox-group
                                                v-model="filterByTag"
                                                name="checkboxgroup"
                                                :options="tempTags"
                                                @change="onChangeTagFilter"
                                            >
                                            </a-checkbox-group>

                                            <div class="d-flex justify-content-center" v-if="seeMoreTagStatus">
                                                <base-button tag="a" size="small" href="#" type="primary" class="text-uppercase" @click.prevent="seeMoreTag">
                                                    See more
                                                </base-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9 pb-2">
                            <div class="row">
                                <div class="col-6 col-xs-3 col-sm-3 col-md-3 col-lg-3 pb-2" v-for="data in gData">
                                    <router-link :to="{ name: 'product', params: { id: data.id }}"
                                    class="mt-4">
                                    {{data.images_url}}
                                        <div class="card-wrapper d-flex justify-content-center">
                                            <div class="card rounded-0" @mouseenter="mouseover(data.id,data.product_type)" @mouseleave="mouseleave(data.id)">
                                                <div class="card-img-wrapper">
                                                    <template>
                                                        <v-lazy-image class="card-img-top img-responsive" v-if="data.images_url!=null && data.images_url!=''" :src="showImage(data.images_url)"  style = "width:15rem"/>
                                                        <v-lazy-image class="card-img-top img-responsive" v-else style="width:16rem" :src="imageUrl+'/product-default.png'" />
                                                    </template>
                                                </div>
                                                <div class="card-body bg-F9F9F9" v-bind:style="[(hover == true && hoverId == data.id && data.product_type=='M' && storeDetails.is_allow_add_to_cart == true) ? {'height':'79%!important'} : (hover == true && hoverId == data.id && data.product_type!='M' && storeDetails.is_allow_add_to_cart == true) ? {'height':'40%!important'} : (hover == true && hoverId == data.id && data.product_type!='M' && storeDetails.is_allow_add_to_cart != true) ? {'height':'25%!important'} : (hover == true && hoverId == data.id && data.product_type=='M' && storeDetails.is_allow_add_to_cart != true) ? {'height':'65%!important'} : {}]">
                                                    <h5 class="card-title" style="white-space: nowrap;">{{limitStringLength(30,data.name)}}
                                                        <div>
                                                            <h5 class="font-weight-bold">
                                                                &#8369;{{formatPrice(data.retail_price)}}
                                                            </h5>
                                                        </div>
                                                    </h5>
                                                    <div class="card-content">
                                                        <small class="mt-3 row" v-if="data.product_type=='M' && hoverDetails.sizes!=undefined">
                                                            <span class="col text-dark font-weight-bold">Size:</span>
                                                            <span class="col text-dark font-weight-bold" v-for="size in hoverDetails.sizes">{{size.name}}</span>
                                                        </small>
                                                        <small class="row mt-2" v-if="data.product_type=='M' && hoverDetails.colors!=undefined">
                                                            <span class="col text-dark  font-weight-bold">Color:</span>
                                                            <span class="col text-dark  font-weight-bold" v-for="color in hoverDetails.colors">{{color.name}}</span>
                                                        </small>
                                                        <small class="row mt-2" v-if="data.product_type=='M' && hoverDetails.designs!=undefined">
                                                            <span class="col text-dark font-weight-bold">Design:</span>
                                                            <span class="col text-dark  font-weight-bold" v-for="design in hoverDetails.designs">{{design.name}}</span>
                                                        </small>
                                                    </div>
                                                    <div v-if="storeDetails.is_allow_add_to_cart == true" class="mt-1">
                                                        <base-button tag="a" size="small" href="#" type="primary" class="text-uppercase" @click.prevent="addToCart">
                                                            Add to Cart
                                                        </base-button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                                <div class="col-lg-12 justify-content-between align-items-center p-5 mb-5 mt-5" v-if="gData.length <=0">
                                    <h1 class="display-3  text-center">{{gData.length}} Result {{$route.query.search !=null ? ' for "' + $route.query.search+ '"' : '' }}
                                    </h1>
                                    <p class="lead  text-center">We couldn't find what you're looking for. <br> Please try different keywords.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-bind:class="{'mb-lg-5 pb-lg-5': gData.length<4 ? true : false }" v-else>
                        <div class="col-6 col-xs-3 col-sm-3 col-md-3 col-lg-3 pb-3" v-for="data in gData">
                            <router-link :to="{ name: 'product', params: { id: data.id }}"
                            class="mt-4">
                                <div class="card-wrapper d-flex justify-content-center">
                                    <div class="card rounded-0" @mouseenter="mouseover(data.id,data.product_type)" @mouseleave="mouseleave(data.id)">
                                        <div class="card-img-wrapper">
                                            <template>
                                                <v-lazy-image class="card-img-top img-responsive" v-if="data.images_url!=null && data.images_url!=''" :src="showImage(data.images_url)"  style = "width:15rem"/>
                                                <v-lazy-image class="card-img-top img-responsive" v-else style = "width:16rem" :src="imageUrl+'/product-default.png'" />
                                            </template>
                                        </div>
                                        <div class="card-body" v-bind:style="[(hover == true && hoverId == data.id && data.product_type=='M' && storeDetails.is_allow_add_to_cart == true) ? {'height':'79%!important'} : (hover == true && hoverId == data.id && data.product_type!='M' && storeDetails.is_allow_add_to_cart == true) ? {'height':'40%!important'} : (hover == true && hoverId == data.id && data.product_type!='M' && storeDetails.is_allow_add_to_cart != true) ? {'height':'25%!important'} : (hover == true && hoverId == data.id && data.product_type=='M' && storeDetails.is_allow_add_to_cart != true) ? {'height':'65%!important'} : {}]">
                                            <h5 class="card-title" style="white-space: nowrap;">{{limitStringLength(30,data.name)}}
                                                <div>
                                                    <h5 class="font-weight-bold">
                                                        &#8369;{{formatPrice(data.retail_price)}}
                                                    </h5>
                                                </div>
                                            </h5>
                                            <div class="card-content">
                                                <small class="mt-3 row" v-if="data.product_type=='M' && hoverDetails.sizes!=undefined">
                                                    <span class="col text-dark font-weight-bold">Size:</span>
                                                    <span class="col text-dark font-weight-bold" v-for="size in hoverDetails.sizes">{{size.name}}</span>
                                                </small>
                                                <small class="row mt-2" v-if="data.product_type=='M' && hoverDetails.colors!=undefined">
                                                    <span class="col text-dark  font-weight-bold">Color:</span>
                                                    <span class="col text-dark  font-weight-bold" v-for="color in hoverDetails.colors">{{color.name}}</span>
                                                </small>
                                                <small class="row mt-2" v-if="data.product_type=='M' && hoverDetails.designs!=undefined">
                                                    <span class="col text-dark font-weight-bold">Design:</span>
                                                    <span class="col text-dark  font-weight-bold" v-for="design in hoverDetails.designs">{{design.name}}</span>
                                                </small>
                                            </div>
                                            <div v-if="storeDetails.is_allow_add_to_cart == true" class="mt-1">
                                                <base-button tag="a" size="small" href="#" type="primary" class="text-uppercase" @click.prevent="addToCart">
                                                    Add to Cart
                                                </base-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </router-link>
                        </div>
                        <div class="col-lg-12 justify-content-between align-items-center p-5 mb-5 mt-5" v-if="gData.length <=0">
                            <h1 class="display-3  text-center">{{gData.length}} Result {{$route.query.search !=null ? ' for "' + $route.query.search+ '"' : '' }}
                            </h1>
                            <p class="lead  text-center">We couldn't find what you're looking for. <br> Please try different keywords.</p>
                        </div>
                    </div>
                    <div class="row pb-4" v-if="seeMoreStatus">
                        <div class="col-md-12 d-flex justify-content-center">
                            <base-button tag="a" size="small" href="#" type="primary" class="text-uppercase" @click.prevent="seeMore">
                                See more
                            </base-button>
                        </div>
                    </div>
                </a-spin>
            </div>
        </section>
    </div>
</template>
<script>
import secureStorage from '../../controllers/secureStorage.js'
import HTTPRequest from '../../controllers/httpRequest.js'
import { mapState, mapActions } from 'vuex'
var component_x;
var timer;
export default {
    components: {
        secureStorage,
        HTTPRequest
    },
    computed: {
        ...mapState(['endPoint', 'parameters','publicUrl'])
    },
    data() {
        return {
            limit:12,
            gData:[],
            collection_name:null,
            spinning:false,
            collection_description:null,
            hover:false,
            hoverId:-1,
            hoverDetails:{},
            imageUrl:null,
            salesChannelId:null,
            storeDetails:[],
            OrderListData:[],
            search:null,
            seeMoreStatus:true,
            SortbyData:[
                {name: "Alphabetically, A-Z",value:0},
                {name: "Alphabetically, Z-A",value:1},
                {name: "Price, Low to High",value:2},
                {name: "Price, High to Low",value:3},
            ],
            sortBy:0,
            tagLimit:10,
            tempTags:[],
            TagDetails:[],
            filterByTag:null,
            filterByTagValue:null,
            checked:false,
            seeMoreTagStatus:true,
            customerLoginStatus:null,
            windowWidth: window.innerWidth,
        }
    },
    mounted: async function(){
        var autoLogin = secureStorage.getItem("ecomLoggedIn")
        console.log(this.windowWidth)
        component_x = this
        if(autoLogin == true){
            this.salesChannelId = secureStorage.getItem("SalesChannelDetails").id
            this.productsData()
            this.imageUrl = this.publicUrl + 'product_images'
            this.storeDetails = secureStorage.getItem("SalesChannelDetails")
            this.customerLoginStatus = secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-CustomerLoginStatus")
            this.OrderList()
            console.log(this.storeDetails)
            if (this.storeDetails.ui_layout == 2){
                this.getProductTags(null)
            }
        }else{
            this.$router.push({ name: 'loading_screen', params: { returnUrl: 'catalog', storeId:this.$route.params.storeId }})
        }
    },
    watch:{
        '$route.params.collectionId': function (id) {
            this.productsData()
            this.seeMoreStatus = true
        },
        '$route.query.search': function(){
            this.productsData()
            this.filterByTag = null
            this.filterByTagValue = null
            this.seeMoreStatus = true
        },
        'sortBy': function(){
            this.productsData()
            this.seeMoreStatus = true
        },
        'filterByTagValue':function(){
            this.productsData()
            this.seeMoreStatus = true
        }
    },
    methods:{
        productsData: async function(offset){
            this.$emit('showFooterAndHeader', event)
            this.$emit('showSearchInput', event)
            this.spinning = true;
            this.search = this.$route.query.search;
            var off = offset!=null ? offset : 0;
            var collection = this.$route.params.collectionId != null ? '&collection_id='+this.$route.params.collectionId : ''
            var search = this.$route.query.search != null ? '&search='+this.$route.query.search : ''
            var sort_by,order;
            switch (this.sortBy) {
                case 0:
                    sort_by = "name"
                    order = "ASC"
                break;
                case 1:
                    sort_by = "name"
                    order = "DESC"
                break;
                case 2:
                    sort_by = "retail_price"
                    order = "ASC"
                break;
                case 3:
                    sort_by = "retail_price"
                    order = "DESC"
                break;
                default:
                    sort_by = "sequence_no"
                    order = "ASC"
                break;
            }
            var sort = '&sort_by='+sort_by+'&order='+order
            var filter = this.filterByTagValue !=null ? '&filter_by='+this.filterByTagValue : ''
            var response = await HTTPRequest.getRequest(this.endPoint + 'sales_channel_products?id='+this.salesChannelId+'&offset='+off+'&limit='+this.limit+''+collection+''+search+''+sort+''+filter, null)
            if (response.length >=this.limit){
                this.seeMoreStatus = true
            }else{
                this.seeMoreStatus = false
            }
            if (offset!=null){
                this.gData = this.gData.concat(response)
            }else{
                this.gData = response
            }
            if (this.$route.params.collectionId !=null){
                var gData = secureStorage.getItem("collections");
                var index = gData.findIndex(x=> x.id == this.$route.params.collectionId)
                this.collection_name = gData[index].collection_name;
                this.collection_description = gData[index].collection_description;
            }
            this.spinning = false;
        },
        mouseoverFetch: async function(id,product_type){
                this.hover = true
                this.hoverId = id
                var response = await HTTPRequest.getRequest(this.endPoint + 'sales_channel_products/' + id + '?sales_channel_id=' + this.salesChannelId, null)
                console.log(response)
                if (response["error"] == undefined){
                    this.hoverDetails = response
                    this.hoverDetails.quantity =1;
                }
        },
        mouseover(id,product_type){
            timer = setTimeout(function () { this.mouseoverFetch(id,product_type) }.bind(this), 500)
        },    
        mouseleave: function(id){
            clearInterval(timer);
            this.hover = false
            this.hoverDetails = {}
            this.hoverId = -1
        },
        addToCart:async function(){
            var productIndex = -1;
            console.log(this.hoverDetails)
            switch (this.hoverDetails.product_type) {
                case "M":
                    var color_status = false,size_status = false, design_status = false; 
                    color_status = this.hoverDetails.colors!=null ? true : false
                    size_status = this.hoverDetails.sizes!=null ? true : false
                    design_status = this.hoverDetails.designs!=null ? true : false
                    switch (true) {
                        case (color_status && size_status && design_status):
                            var subProductIndex = this.hoverDetails.sub_products.findIndex(x=> x.size_id == this.hoverDetails.sizes[0].id && x.color_id == this.hoverDetails.colors[0].id && x.design_id == this.hoverDetails.designs[0].id)
                        break;
                        case (!color_status && size_status && design_status):
                            var subProductIndex = this.hoverDetails.sub_products.findIndex(x=> x.size_id == this.hoverDetails.sizes[0].id && x.design_id == this.hoverDetails.designs[0].id)
                        break;
                        case (color_status && !size_status && design_status):
                            var subProductIndex = this.hoverDetails.sub_products.findIndex(x.color_id == this.hoverDetails.colors[0].id && x.design_id == this.hoverDetails.designs[0].id)
                        break;
                        case (color_status && size_status && !design_status):
                            var subProductIndex = this.hoverDetails.sub_products.findIndex(x=> x.size_id == this.hoverDetails.sizes[0].id && x.color_id == this.hoverDetails.colors[0].id)
                        break;
                        case (!color_status && !size_status && design_status):
                            var subProductIndex = this.hoverDetails.sub_products.findIndex(x.design_id == this.hoverDetails.designs[0].id)
                        break;
                        case (color_status && !size_status && !design_status):
                            var subProductIndex = this.hoverDetails.sub_products.findIndex(x.color_id == this.hoverDetails.colors[0].id)
                        break;
                        case (!color_status && size_status && !design_status):
                            var subProductIndex = this.hoverDetails.sub_products.findIndex(x=> x.size_id == this.hoverDetails.sizes[0].id)
                        break;
                        default:
                        break;
                    }
                    if (subProductIndex >=0){
                        if(this.customerLoginStatus){
                            productIndex = this.OrderListData.findIndex(x=> x.product_id == this.hoverDetails.sub_products[subProductIndex].id)
                            if (productIndex >=0){
                                var id = this.OrderListData[productIndex].id
                                var quantity = this.OrderListData[productIndex].quantity + this.hoverDetails.quantity
                                var put_request = await HTTPRequest.putRequest(this.endPoint + 'sales_channel_cart_items/' +id, null, {quantity:quantity}) 
                                if (put_request["error"] == undefined){
                                    await this.OrderList()
                                    this.$emit('getOrderCount', this.OrderListData)
                                    this.$notification['success']({
                                        message: 'Successfully added',
                                        description: "Just Added to your cart : "+this.hoverDetails.name
                                    });
                                }
                            }else{
                                var cartItemPayLoad = {
                                    cart_item:{
                                        customer_id:secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-CustomerDetailsLogin").id,
                                        quantity: this.hoverDetails.quantity,
                                        product_id:this.hoverDetails.sub_products[subProductIndex].id,
                                        sales_channel_id:this.hoverDetails.sales_channel_id,
                                    }
                                }
                                var post_request = await HTTPRequest.postRequest(this.endPoint + 'sales_channel_cart_items', null, cartItemPayLoad) 
                                if (post_request["error"] == undefined){
                                    await this.OrderList()
                                    this.$emit('getOrderCount', this.OrderListData)
                                    this.$notification['success']({
                                        message: 'Successfully added',
                                        description: "Just Added to your cart : "+this.hoverDetails.name
                                    });
                                }
                            }
                        }else{
                            productIndex = this.OrderListData.findIndex(x=> x.id == this.hoverDetails.sub_products[subProductIndex].id)
                            if (productIndex >=0){
                                this.OrderListData[productIndex].quantity+=this.hoverDetails.quantity
                                this.$notification['success']({
                                    message: 'Successfully added',
                                    description: "Just Added to your cart : "+this.hoverDetails.name
                                });
                            }else{
                                this.hoverDetails.sub_products[subProductIndex].quantity = this.hoverDetails.quantity
                                this.OrderListData.push(this.hoverDetails.sub_products[subProductIndex])
                                this.$notification['success']({
                                    message: 'Successfully added',
                                    description: "Just Added to your cart : "+this.hoverDetails.name
                                });
                                secureStorage.setItem("OrderListData"+secureStorage.getItem("SalesChannelDetails").name,this.OrderListData)
                                this.$emit('getOrderCount', this.OrderListData)
                            }
                        }
                    }
                break;
                default:
                    if(this.customerLoginStatus){
                        productIndex = this.OrderListData.findIndex(x=> x.product_id == this.hoverDetails.id)
                        if (productIndex>=0){
                            var id = this.OrderListData[productIndex].id
                            var quantity = this.OrderListData[productIndex].quantity + this.hoverDetails.quantity
                            var put_request = await HTTPRequest.putRequest(this.endPoint + 'sales_channel_cart_items/' +id, null, {quantity:quantity}) 
                            if (put_request["error"] == undefined){
                                await this.OrderList()
                                this.$emit('getOrderCount', this.OrderListData)
                                this.$notification['success']({
                                    message: 'Successfully added',
                                    description: "Just Added to your cart : "+this.hoverDetails.name
                                });
                            }
                        }else{
                            var cartItemPayLoad = {
                                cart_item:{
                                    customer_id:secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-CustomerDetailsLogin").id,
                                    quantity: this.hoverDetails.quantity,
                                    product_id:this.hoverDetails.id,
                                    sales_channel_id:this.hoverDetails.sales_channel_id,
                                }
                            }
                            var post_request = await HTTPRequest.postRequest(this.endPoint + 'sales_channel_cart_items', null, cartItemPayLoad) 
                            if (post_request["error"] == undefined){
                                await this.OrderList()
                                this.$emit('getOrderCount', this.OrderListData)
                            }
                        }
                    }else{
                        productIndex = this.OrderListData.findIndex(x=> x.id == this.hoverDetails.id)
                        if (productIndex >=0){
                            this.OrderListData[productIndex].quantity+=this.hoverDetails.quantity
                            this.$notification['success']({
                                message: 'Successfully added',
                                description: "Just Added to your cart : "+this.hoverDetails.name
                            });
                        }else{
                            this.OrderListData.push(this.hoverDetails)
                            this.$notification['success']({
                                message: 'Successfully added',
                                description: "Just Added to your cart : "+this.hoverDetails.name
                            });
                            secureStorage.setItem("OrderListData"+secureStorage.getItem("SalesChannelDetails").name,this.OrderListData)
                            this.$emit('getOrderCount', this.OrderListData)
                        }
                    }
                break;
            }
        },
        onSearch(value){
            var params = this.$router.currentRoute.params
            params.storeId = this.$route.params.storeId
            if (value==''){
                this.$router.push({ name: this.$router.currentRoute.name, params: params })
            }else{
                this.$router.push({ name: this.$router.currentRoute.name, params: params, query: { search: value }})
            }
            console.log(this.$route)
            this.search = null
        },
        seeMore(){
            this.productsData(this.gData.length)
        },
        getProductTags: async function(offset){
            var off = offset!=null ? offset : 0;
            var response = await HTTPRequest.getRequest(this.endPoint + 'sales_channel_products/get_product_tags?id=' + this.salesChannelId + '&offset='+off+'&limit='+this.tagLimit, null)
            if (response["error"] == undefined){
                if (response.length >=this.tagLimit){
                    this.seeMoreTagStatus = true
                }else{
                    this.seeMoreTagStatus = false
                }
                if (offset!=null && offset!=0){
                    this.TagDetails = this.TagDetails.concat(response)
                    response.forEach((value, index) => {
                        var arr = this.splitArray(value.tag)
                        if (this.tempTags.length<=0){
                            this.tempTags = arr
                        }else{
                            this.tempTags = [].concat(this.tempTags,arr)
                        }
                    })
                    this.tempTags = this.tempTags.filter((item,index) => this.tempTags.indexOf(item) === index)
                }else{
                    this.TagDetails = response
                    this.tempTags = []
                    response.forEach((value, index) => {
                        var arr = this.splitArray(value.tag)
                        if (this.tempTags.length<=0){
                            this.tempTags = arr
                        }else{
                            this.tempTags = [].concat(this.tempTags,arr)
                        }
                    })
                    this.tempTags = this.tempTags.filter((item,index) => this.tempTags.indexOf(item) === index)
                }
                console.log(this.tempTags)
            }
        },
        formatPrice: function(value) {
            let val = (value/1).toFixed(2).replace('.', '.')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        limitStringLength(length,string){
            var trimmedString = string.slice(0, length)
            return trimmedString
        },
        splitArray(array){
            var arr = array.split(',')
            return arr
        },
        onChangeTagFilter(e) {
            if (this.filterByTagValue!=null){
                var search = e.findIndex(x=> x == this.filterByTagValue)
                if (search>=0){
                    e.splice(search,1)
                }
            }
            this.filterByTagValue = e[e.length-1]
            this.filterByTag = [this.filterByTagValue]
            e = [this.filterByTagValue]
            console.log(this.filterByTagValue)
        },
        seeMoreTag(){
            this.getProductTags(this.TagDetails.length)
        },
        OrderList: async function(){
            if (this.customerLoginStatus){
                var response = await HTTPRequest.getRequest(this.endPoint + 'sales_channel_cart_items?account_id='+this.storeDetails.account_id+'&sales_channel_id='+this.storeDetails.id+'&customer_id='+secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-CustomerDetailsLogin").id, null)
                console.log(response)
                this.OrderListData = response;
            }else{
                var gData = secureStorage.getItem("OrderListData"+this.storeDetails.name);
                if (gData !='' && gData !=null){
                    this.OrderListData = gData;
                    this.totalAmount = 0;
                }
            }
        },
        showImage(images){
            try {
                var imgs = JSON.parse(images)
                if (imgs.length > 0){
                    return imgs[0].url
                }else {
                    return this.imageUrl+'/product-default.png'
                }
            } catch (error) {
                return this.imageUrl+'/product-default.png'
            }
        }
    }
};
</script>
<style scoped>

.card-wrapper {
  margin-bottom: 30px;
}
.card-image .card .card-img-wrapper {
  height: 100%;
}
.card-image .card .card-body {
  display: none;
}
.card-image-title-description .card .card-img-wrapper {
  max-height: 160px;
}
.card-image-title-description .card {
  position: relative;
  min-height: 300px;
}
.card-image-title-description .card .card-body {
  height: auto;
  position: relative;
  top: 0;
  margin-bottom: -70px;
}
.card-image-title-description .card:hover .card-body {
  top: -70px;
}
.card-image-title-description .card .card-body .card-title {
  margin-bottom: .75rem;
}
.card {
  display: inline-block;
  position: relative;
  overflow: hidden;
  min-height: 320px;
  height: 100%;
}
.card:hover {
  box-shadow: 8px 12px 31px -10px #ab98ab;
}
.card-img-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50%;
  overflow: hidden;
}
.card-body .card-title {
  margin-bottom: calc(50% + 30px);
  transition: 1.5s ease;
}
.card:hover .card-body .card-title {
  margin-bottom: .15rem;
}

.card-body {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 25%;
  background-color: #fff;
  transition: 1.5s ease;
}
.card-content {
  left: 0;
  right: 0;
  overflow: hidden;
  width: 100%;
  height: auto;
  transition: 1.5s ease;
}
.v-lazy-image {
    filter: blur(10px);
    transition: filter 0.7s;
}
.v-lazy-image-loaded {
    filter: blur(0);
}
@media (min-width: 769px){
    .card {
        min-height: 320px!important;
    }
}
</style>
<style>
.ant-checkbox-group-item {
    display: block;
    padding-bottom: 4px;
    padding-top: 4px;
}
.filter-tag {
    width: 100%;
}
@media (max-width: 767.98px){
    .filter-tag {
       width: 91%;
    }
    .card {
        min-height: 280px!important;
    }
}
.bg-F9F9F9{
    background-color: #F9F9F9!important;
}
</style>